import { ChatLayout } from '@/layouts';
import { Layout as FirstLoginLayout } from '@/pages/FirstLogin/layouts';
import { EKioskRouterNames } from '@/types';
import { lazy } from 'react';
import { Outlet, RouteObject } from 'react-router-dom';

const CreateAppointmentPage = lazy(
  () => import('@/pages/Dashboard/pages/CreateAppointment'),
);
const AppointmentConfirmation = lazy(
  () => import('@/pages/Dashboard/pages/AppointmentConfirmation'),
);
const FormBuilderEntry = lazy(
  () => import('@/pages/FormBuilderEntries/pages/FormBuilderEntry'),
);

const Chat = lazy(() => import('@/pages/Chats/pages/Chat'));
const Encounter = lazy(() => import('@/pages/Encounters/pages/Encounter'));
const WaitingRoom = lazy(
  () => import('@/pages/WaitingRooms/pages/WaitingRoom'),
);

const DashboardRoleControl = lazy(
  () => import('@/pages/Dashboard/pages/DashboardRoleControl'),
);

const SessionEnded = lazy(() => import('@/pages/SessionEnded'));

const UserAgreementPage = lazy(
  () => import('@/pages/FirstLogin/pages/UserAgreement'),
);

const FormRoleUniversalPage = lazy(
  () => import('@/pages/FirstLogin/pages/FormRoleUniversal'),
);

export const kioskPrivateRoutes: RouteObject[] = [
  {
    path: EKioskRouterNames.KIOSK__FIRST_LOGIN,
    element: <FirstLoginLayout />,
    children: [
      {
        index: true,
        element: <UserAgreementPage />,
      },
      {
        path: EKioskRouterNames.KIOSK__FIRST_LOGIN__PARTICIPANT_FORM,
        element: <FormRoleUniversalPage />,
      },
    ],
  },
  {
    path: EKioskRouterNames.KIOSK__FORM_BUILDER_ENTRY_EDIT,
    element: <FormBuilderEntry variant="edit" />,
  },
  {
    path: EKioskRouterNames.KIOSK__FORM_BUILDER_ENTRY_VIEW,
    element: <FormBuilderEntry variant="view" />,
  },
  {
    path: EKioskRouterNames.KIOSK__DASHBOARD,
    element: <Outlet />,
    children: [
      { index: true, element: <DashboardRoleControl /> },
      {
        path: EKioskRouterNames.KIOSK__DASHBOARD__SCHEDULE_APPOINTMENT,
        element: <CreateAppointmentPage scheduleType="scheduled" />,
      },
      {
        path: EKioskRouterNames.KIOSK__DASHBOARD__SEE_PROVIDER_NOW,
        element: <CreateAppointmentPage scheduleType="on_demand" />,
      },
      {
        path: EKioskRouterNames.KIOSK__DASHBOARD__APPOINTMENT_CONFIRMATION,
        element: <AppointmentConfirmation />,
      },
    ],
  },
  {
    element: <ChatLayout />,
    children: [
      {
        path: EKioskRouterNames.KIOSK__WAITING_ROOM,
        element: <Outlet />,
        children: [
          {
            index: true,
            element: <WaitingRoom />,
          },
          {
            path: EKioskRouterNames.KIOSK__LEFT,
            element: <SessionEnded variant="waitingRoom" />,
          },
        ],
      },
      {
        path: EKioskRouterNames.KIOSK__CHAT,
        element: <Outlet />,
        children: [
          {
            index: true,
            element: <Chat />,
          },
          {
            path: EKioskRouterNames.KIOSK__SESSION_ENDED,
            element: <SessionEnded variant="session" />,
          },
        ],
      },
      {
        path: EKioskRouterNames.KIOSK__ENCOUNTER,
        element: <Outlet />,
        children: [
          {
            index: true,
            element: <Encounter />,
          },
          {
            path: EKioskRouterNames.KIOSK__SESSION_ENDED,
            element: <SessionEnded variant="session" />,
          },
        ],
      },
    ],
  },
];
